import ResourceService from "./resource.service";
import Vue from "vue";
class DriverAllowanceService extends ResourceService {
  static get resource() {
    return "driver-allowance";
  }

  static exportDriverAllowance(params) {
    const url = `${this.resource}/export`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url,{
          responseType: "blob",
          params,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default DriverAllowanceService;

